import { TeamsSortField } from "@custom-types/teams-types";
import { TeamsTableColumnField } from "@components/table/teams/teams-table-types";

/** All available column fields for the teams table */
export const TEAMS_TABLE_COLUMNS = [
  "name",
  "users",
  "creationDate",
  "workspaceRole",
  "options",
] as const;

/** The labels for the columns in the teams table */
export const TEAMS_TABLE_COLUMN_LABELS: Record<TeamsTableColumnField, string> =
  {
    name: "Team name",
    users: "Users",
    creationDate: "Creation date",
    workspaceRole: "Workspace role",
    options: "Options",
  };

/** Sortable column fields for the teams table */
export const TEAMS_SORTABLE_FIELDS = [
  "name",
  "users",
  "creationDate",
  "workspaceRole",
] as const;

/** The labels for the sortable teams columns */
export const TEAMS_SORT_COLUMN_LABELS: Record<TeamsSortField, string> = {
  name: "Team name",
  users: "Users",
  creationDate: "Creation date",
  workspaceRole: "Workspace role",
};
